"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultContent = exports.getDefaultContent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _types = require("../types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//-start
var institutions = {
  textTitle: 'Verify your income',
  textIntro: '',
  textLoading: 'Loading institutions...',
  labelSelectInstitution: 'Select the bank your income is paid into',
  labelSelectInstitutionSecondary: 'Choose a different bank',
  labelOther: 'Other',
  selectPlaceholder: 'Select an option',
  buttonSubmit: 'Next'
};
var login = {
  textTitle: 'Log in to your {{institutionName}} account',
  textLoading: 'Loading...',
  buttonSubmit: 'One time Bank Connect',
  buttonBack: 'Back',
  textTermsAndConditions: "By clicking <b>'{{buttonSubmit}}'</b> you agree to the ",
  textAnd: 'and',
  textDisclaimer: "This service is provided by BankStatements.com.au (ABN 89 166 277 845). Your login details are never stored, they are secured with bank level 256 bit encryption and your data doesn't leave Australia.",
  linkTermsAndConditions: 'User Terms & Conditions',
  linkPrivacyPolicy: 'Privacy Policy',
  linkEncryptionInformation: 'See more about how this works',
  // note these links open in new tabs
  urlUserTermsAndConditions: '#',
  urlPrivacyPolicy: '#',
  urlEncryptionInformation: '#'
};

var nzLogin = _objectSpread(_objectSpread({}, login), {}, {
  urlUserTermsAndConditions: 'https://bankstatements.com.au/about/terms',
  urlPrivacyPolicy: 'https://www.illion.co.nz/privacy-policy-risk-marketing-solutions',
  urlEncryptionInformation: 'https://bankstatements.co.nz',
  textDisclaimer: 'This service is provided by BankStatements.com.au (ABN 89 166 277 845). Your log in details are never stored and they are secured with bank level 256 bit encryption.'
});

var mfa = {
  textTitle: '{{institutionName}} require further verification',
  buttonSubmit: 'Confirm',
  buttonBack: 'Back'
};
var accounts = {
  textTitle: 'Select account',
  textInfo: 'Select which account your income gets paid into',
  textHelp: 'You can select more than one account',
  labelYourAccounts: 'Select accounts',
  buttonSubmit: 'Next',
  a11yTextAccountName: 'account name',
  a11yTextAccountNumber: 'account number',
  a11yTextAvailableBalance: 'available balance',
  errorMessageFetchingData: 'Error fetching statement data',
  errorMessageCannotFetchData: 'Cannot fetch statement data'
};
var password = {
  textTitle: '{{institutionName}} requires you to confirm your banking password',
  buttonSubmit: 'Continue',
  buttonBack: 'Back'
};
var income = {
  textTitle: 'Select your income',
  labelAccount: 'BSB: {{bsb}}  ACC: {{accountNumber}}',
  optionNoIncome: 'None are my income',
  totalIncomeNotShown: 'Tick this box to update your total income in the next step',
  buttonSubmit: 'Confirm income',
  buttonBack: 'Back',
  validationPleaseSelectIncome: 'Please select from the options above',
  validationCannotSeeTotalIncome: 'Please select an option above, or select this checkbox if your total income is not shown.',
  errorMessageSubmittingIncome: 'Error submitting income'
};
var common = {
  buttonClose: 'Close',
  linkSecureMessage: 'Safely and securely verify your income',
  linkLoginToDifferentBank: 'Log in to a different bank',
  textSecureMessageTitle: 'Online Bank Connect',
  textSecureMessageSubtitle: 'Securely connecting with your bank',
  textSecureMessageContent: "Latitude has partnered with Illion Bank Statements to securely provide digitally encrypted statements directly from your bank. It's a safe and secure service. <b>Your login details are never stored and it is a one time access only.</b> This is the fastest way to get a decision."
}; //-end

var getLogin = function getLogin(countryCode) {
  switch (countryCode) {
    case _types.Region.NZ:
      return nzLogin;

    default:
      return login;
  }
};

var getDefaultContent = function getDefaultContent(countryCode) {
  return {
    common: common,
    institutions: institutions,
    login: getLogin(countryCode),
    mfa: mfa,
    accounts: accounts,
    password: password,
    income: income
  };
};

exports.getDefaultContent = getDefaultContent;
var defaultContent = {};
exports.defaultContent = defaultContent;